<template>
  <v-row class="mb-15 mt-2" justify="center">
        <v-col cols="12" class="text-center">
            <h1 class="pa-0 ma-0" >Klikk & hent</h1>
            <span> - reserver dine favorittprodukter hos oss!</span>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pa-2">
            <v-card elevation="0" color="rgba(197, 197, 192, 0.3)" class="d-flex align-center pa-4" style="height: 100%">
                    <v-icon
                        color="primary"
                        size="45"
                        class="pr-1"
                        >
                        shopping_cart
                    </v-icon>
                    <v-divider vertical class="mr-3 ml-2"></v-divider>
                    <div>
                        <h3>1. Velg produkter</h3>
                        <p>Legg produktene i handlekurven og fullfør bestillingen</p>
                    </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pa-2">
            <v-card color="rgba(197, 197, 192, 0.3)" elevation="0" class="d-flex align-center pa-4" style="height: 100%">
                <v-icon
                    color="primary"
                    size="45"
                    class="pr-1"
                    >
                    person
                </v-icon>
                <v-divider vertical class="mr-3 ml-2"></v-divider>
                <div>
                    <h3>2. Bestillingen klargjøres</h3>
                    <p>Vanligvis klar innen 30 min.</p>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pa-2">
            <v-card color="rgba(197, 197, 192, 0.3)" elevation="0" class="d-flex align-center pa-4" style="height: 100%">
                <v-icon
                    color="primary"
                    size="45"
                    class="pr-1"
                    >
                    store
                </v-icon>
                <v-divider vertical class="mr-3 ml-2"></v-divider>
                <div>
                    <h3>3. Hent din bestilling</h3>
                    <p>Varene står klar i salongen</p>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {

}
</script>

<style>

</style>